/**
 * The handle policy, shared verbatim by the client (friendly rejection at
 * every callsign entry point), the Worker (authoritative: board and
 * submission names) and the race rooms (live display names). One list,
 * zero drift; the Worker bundles this file, so the server can never be
 * more permissive than the UI.
 *
 * Scope is deliberately a hate-speech FLOOR, not a profanity filter:
 * unambiguous slurs, checked after leetspeak normalisation (the incident
 * that created this file used a plain spelling, but 1 and 3 are free
 * disguises under the handle charset). Short terms that live inside
 * ordinary words match only as the whole handle (COON in RACCOON must
 * pass); longer ones match as substrings (a suffix does not launder a
 * slur). SNIGGER is collateral damage and stays blocked; that trade is
 * standard and correct.
 */

const LEET = { 0: 'O', 1: 'I', 3: 'E', 4: 'A', 5: 'S', 6: 'G', 7: 'T', 8: 'B' };
const SUBSTRINGS = ['NIGGER', 'NIGGA', 'FAGGOT', 'WETBACK', 'HITLER', 'RETARD', 'TRANNY'];
const EXACT = ['KKK', 'COON', 'CHINK', 'KIKE', 'SPIC', 'FAG', 'NAZI', 'RAPIST'];

function normalize(name) {
  return String(name ?? '')
    .toUpperCase()
    .replace(/[0-9]/g, (d) => LEET[d] ?? d)
    .replace(/[ _-]/g, '');
}

/** True when a handle is unacceptable regardless of who is asking. */
export function isSlurHandle(name) {
  const n = normalize(name);
  if (!n) return false;
  if (SUBSTRINGS.some((s) => n.includes(s))) return true;
  return EXACT.includes(n);
}

/**
 * The free-text variant, for content the sweep reviews (level blurbs,
 * sign text, feedback). Per-word so RACCOON in prose passes, plus a
 * collapsed pass over only the long unambiguous terms so "nig ger" does
 * not launder by spacing. Tuned for a REPORT a human reads, so a rare
 * false positive costs a glance, not a rejection.
 */
export function textContainsSlur(text) {
  const words = String(text ?? '').split(/[^A-Za-z0-9]+/);
  if (words.some((w) => w && isSlurHandle(w))) return true;
  const collapsed = normalize(words.join(''));
  return SUBSTRINGS.some((s) => collapsed.includes(s));
}
